import React, { useCallback } from 'react';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { Currency } from '../types';


type CurrenciesAdminColumnRendererProps = {
  value: Currency,
  rowIndex: number,
}

const CurrenciesAdminColumnRendererFactory = ({
  showModalForEdit,
  showModalForRemove,
}: {
  showModalForEdit: (entity: Currency) => void,
  showModalForRemove: (data: { entityToRemove: Currency, rowIndex: number }) => void,
}) => {
  const CurrenciesAdminColumnRenderer = ({
    value: entity,
    rowIndex,
  }: CurrenciesAdminColumnRendererProps) => {
    const showEditModal = useCallback(() => {
      showModalForEdit(entity);
    }, [entity]);

    const showRemoveModal = useCallback(() => {
      showModalForRemove({ entityToRemove: entity, rowIndex });
    }, [entity, rowIndex]);

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Currency"
          onClick={showEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>

        <button
          className="cell-icon-button"
          title="Remove Currency"
          onClick={showRemoveModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  };
  return CurrenciesAdminColumnRenderer;
};

export default CurrenciesAdminColumnRendererFactory;
